// Where each Victorian court actually sits, taken from each court's own
// locations page (checked 29 Sep 2026):
//   mcv.vic.gov.au/going-court/find-court
//   childrenscourt.vic.gov.au/court-locations
//   countycourt.vic.gov.au/contact-us/locations
//   supremecourt.vic.gov.au/contact-us/locations

const MAGISTRATES = [
  "Broadmeadows", "Dandenong", "Frankston", "Heidelberg", "Melbourne",
  "Moorabbin Justice Centre", "Neighbourhood Justice Centre", "Ringwood",
  "Sunshine", "Wyndham (Werribee)",
  "Ararat", "Bacchus Marsh", "Bairnsdale", "Ballarat", "Benalla", "Bendigo",
  "Castlemaine", "Cobram", "Colac", "Corryong", "Dromana", "Echuca",
  "Edenhope", "Geelong", "Hamilton", "Hopetoun", "Horsham", "Kerang",
  "Korumburra", "Kyneton", "Latrobe Valley (Morwell)", "Mansfield",
  "Maryborough", "Mildura", "Myrtleford", "Nhill", "Orbost", "Ouyen",
  "Portland", "Robinvale", "Sale", "Seymour", "Shepparton", "St Arnaud",
  "Stawell", "Swan Hill", "Wangaratta", "Warrnambool", "Wodonga", "Wonthaggi",
];

const CHILDRENS = [
  "Melbourne", "Broadmeadows", "Dandenong", "Moorabbin", "Wyndham (Werribee)",
  "Ararat", "Bacchus Marsh", "Bairnsdale", "Ballarat", "Benalla", "Bendigo",
  "Colac", "Echuca", "Geelong", "Hamilton", "Horsham", "Korumburra",
  "Latrobe Valley (Morwell)", "Mildura", "Sale", "Seymour", "Shepparton",
  "Stawell", "Swan Hill", "Wangaratta", "Warrnambool", "Wodonga", "Wonthaggi",
];

const COUNTY = [
  "Melbourne", "Bairnsdale", "Ballarat", "Bendigo", "Geelong", "Horsham",
  "Latrobe Valley (Morwell)", "Mildura", "Sale", "Shepparton", "Wangaratta",
  "Warrnambool", "Wodonga",
];

const SUPREME = [
  "Melbourne", "Ballarat", "Bendigo", "Geelong", "Hamilton", "Horsham",
  "Latrobe Valley (Morwell)", "Mildura", "Sale", "Shepparton", "Wangaratta",
  "Warrnambool", "Wodonga",
];

// Melbourne stays first; the rest are alphabetical.
const ordered = (list) => ["Melbourne", ...list.filter((l) => l !== "Melbourne").sort()].filter((l) => list.includes(l));

export const COURT_LOCATIONS_BY_TYPE = {
  "Children's Court": ordered(CHILDRENS),
  "Magistrates' Court": ordered(MAGISTRATES),
  "County Court": ordered(COUNTY),
  "Supreme Court": ordered(SUPREME),
  "Court of Appeal": ["Melbourne"],
  "High Court": ["Melbourne", "Canberra"],
  "Office of the Chief Examiner": ["Melbourne"],
};

export const COURT_TYPE_OPTIONS = [...Object.keys(COURT_LOCATIONS_BY_TYPE), "Other"];
